import { render, staticRenderFns } from "./updBonusList.vue?vue&type=template&id=3b5b7600&scoped=true"
import script from "./updBonusList.vue?vue&type=script&lang=js"
export * from "./updBonusList.vue?vue&type=script&lang=js"
import style0 from "./updBonusList.vue?vue&type=style&index=0&id=3b5b7600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b7600",
  null
  
)

export default component.exports